<template>
  <div class="home">
    <detailsTop
      :isHomeProps="true"
      :topIndex="0"
      @bannerIndexClick="bannerIndexClick"
    />
    <!-- <div class="banner">
      <el-carousel height="480px">
        <el-carousel-item v-for="(item, index) in oneBannerList" :key="index">
          <img :src="baseURL + item.cover" />
        </el-carousel-item>
      </el-carousel>
    </div> -->

    <div class="home-content">
      <div class="home-part1">
        <div class="home-part1-content">
          <p class="part1-title">-企业愿景</p>
          <p class="part1-msg">
            顺势而为，乘势而上，发扬女娲补天精神，传承娲石品质，
            把娲石集团打造成中国百强、百年企业！
          </p>
          <div class="part1-flex">
            <div class="part1-flex-item" @click="jumpPage(1, 0)">
              <div class="item-right">
                <img
                  class="item-black"
                  src="../assets/images/yuanjing-black1.png"
                  alt=""
                />
                <img
                  class="item-white"
                  src="../assets/images/yuanjing-white1.png"
                  alt=""
                />
              </div>
              <div class="item-left">
                <p class="item-left-title">01</p>
                <p class="item-left-msg">企业简介</p>
                <p class="item-left-eng">Corporate Profile</p>
              </div>
            </div>
            <div class="part1-flex-item" @click="jumpPage(3, 0)">
              <div class="item-right">
                <img
                  class="item-black"
                  src="../assets/images/yuanjing-black1.png"
                  alt=""
                />
                <img
                  class="item-white"
                  src="../assets/images/yuanjing-white1.png"
                  alt=""
                />
              </div>
              <div class="item-left">
                <p class="item-left-title">02</p>
                <p class="item-left-msg">企业新闻</p>
                <p class="item-left-eng">Corporate News</p>
              </div>
            </div>
            <div class="part1-flex-item" @click="jumpPage(2, 1)">
              <div class="item-right">
                <img
                  class="item-black"
                  src="../assets/images/yuanjing-black1.png"
                  alt=""
                />
                <img
                  class="item-white"
                  src="../assets/images/yuanjing-white1.png"
                  alt=""
                />
              </div>
              <div class="item-left">
                <p class="item-left-title">03</p>
                <p class="item-left-msg">招投标信息</p>
                <p class="item-left-eng">Tendering and bidding</p>
              </div>
            </div>
            <div class="part1-flex-item" @click="jumpPage(5, 1)">
              <div class="item-right">
                <img
                  class="item-black"
                  src="../assets/images/yuanjing-black1.png"
                  alt=""
                />
                <img
                  class="item-white"
                  src="../assets/images/yuanjing-white1.png"
                  alt=""
                />
              </div>
              <div class="item-left">
                <p class="item-left-title">04</p>
                <p class="item-left-msg">招聘信息</p>
                <p class="item-left-eng">recruitment information</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="home-part2">
        <div class="home-part2-content">
          <p class="home-part2-title">业务范围</p>
          <div class="home-part2-flex">
            <div class="home-part2-left">
              <div class="home-part2-left-item" @mouseenter="changeImg(0)">
                <div class="part2-item-left">01</div>
                <div class="part2-item-middle">
                  <p class="item-mid-top">武汉光谷物联港产业园</p>
                </div>
              </div>
              <div class="home-part2-left-item" @mouseenter="changeImg(1)">
                <div class="part2-item-left">02</div>
                <div class="part2-item-middle">
                  <p class="item-mid-top">阳逻绿能新材智慧物流产业园</p>
                </div>
              </div>
              <div class="home-part2-left-item" @mouseenter="changeImg(2)">
                <div class="part2-item-left">03</div>
                <div class="part2-item-middle">
                  <p class="item-mid-top">黄石阳新绿色建材产业园</p>
                </div>
              </div>
              <div class="home-part2-left-item" @mouseenter="changeImg(3)">
                <div class="part2-item-left">04</div>
                <div class="part2-item-middle">
                  <p class="item-mid-top">四川攀枝花钒钛产业园</p>
                </div>
              </div>
            </div>
            <div class="home-part2-right">
              <el-carousel height="460px" :interval="2000">
                <el-carousel-item v-for="item in bisImgList" :key="item">
                  <img :src="baseURL + item" />
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>

      <div class="home-part3">
        <div class="home-part3-content">
          <div class="home-part3-left">
            <p class="home-part3-title">新闻动态</p>
            <div class="part3-left" @click="jumpDetailPage(newsOne)">
              <div class="part-left-img">
                <el-carousel trigger="click" height="400px">
                  <el-carousel-item
                    v-for="(item, index) in NewsImgList"
                    :key="index"
                  >
                    <img :src="baseURL + item" alt="" />
                  </el-carousel-item>
                </el-carousel>
              </div>

              <div class="text">
                <h5>{{ newsOne.title }}</h5>
                <span>{{ newsOne.createTime }}</span>
                <p>
                  {{ newsOne.introduction }}
                </p>
              </div>
            </div>
          </div>
          <div class="home-part3-right">
            <div class="tabs">
              <span class="fl">公司动态</span>
              <p @click="jumpPage(3)">更多 &gt;</p>
            </div>
            <div class="right-content">
              <ul class="news-list">
                <li
                  v-for="(item, index) in newsList"
                  :key="index"
                  @click="jumpDetailPage(item)"
                >
                  <span class="news-span1">{{ item.createTime }}</span>
                  <span class="news-span2">
                    {{ item.title }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="home-right"></div>
    </div>
    <!-- <goShopping></goShopping> -->
    <pageBottom />
  </div>
</template>

<script>
// @ is an alias to /src
import detailsTop from "@/components/detailsTop.vue";
import pageBottom from "@/components/pageBottom";
import goShopping from "@/components/goShopping.vue";
// import autofit from "autofit.js";

import {
  getTProjectTypeListByIndex,
  getTBannerList,
  selectTNewsPage,
} from "@/api/api.js";

export default {
  name: "Home",
  components: {
    detailsTop,
    pageBottom,
    goShopping,
  },
  data() {
    return {
      newsList: [],
      newsOne: {}, //第一篇新闻
      oneBannerList: [],
      isFloat: false,
      floatIndex: 0,
      pageYOffset: "",
      childList: {},
      NewList: [],
      NewsImgList: [], //新闻的轮播图
      bussinessList: [], //园区的列表
      bisImgList: [], //园区的轮播
    };
  },
  created() {
    this.getNewsList();
    this.getBanner();
    this.getChildList();
    this.getImgList();
  },
  // mounted(){
  //   let options = {
  //           designHeight: 1280,
  //           designWidth: 1920, 
  //           renderDom: ".home", 
  //       }
  //       autofit.init(options)

  // },

  methods: {
    // 获取公司动态列表
    async getNewsList() {
      const { data } = await selectTNewsPage({
        projectTypeParentId: 1,
        projectTypeSubId: 9,
      });
      this.newsList = data.data.list;
      this.newsList.forEach((item) => {
        let date1 = new Date(item.createTime);
        let date2 = date1.getTime();
        item.createTime = this.timestampToTime(date2);
      });
      //第一篇新闻
      this.newsOne = data.data.list[0];
      this.newsOne.cover.split(",").forEach((item) => {
        this.NewsImgList.push(item);
      });
    },

    //日期转换函数
    timestampToTime(timestamp) {
      if (timestamp === 0 || timestamp == null) {
        return "";
      } else {
        var date = new Date(timestamp);
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        return Y + M + D;
      }
    },
    //跳转新闻详情页面
    jumpDetailPage(item) {
      const routeUrl = this.$router.resolve({
        path: "/newDetails",
        query: {
          newsId: item.newsId,
          projectTypeParentId: item.projectTypeParentId,
          topIndex: this.topIndex,
        },
      });
      window.open(routeUrl.href, "_blank");
    },

    // 获取轮播图
    async getBanner() {
      const { data } = await getTBannerList();
      this.oneBannerList = data.data;
    },

    bannerIndexClick(index) {
      // console.log(index)
    },

    async getChildList() {
      const { data } = await getTProjectTypeListByIndex();
      if (data.code === 200) {
        this.NewList = data.data;
      }
    },
    jumpDevelop(num) {
      var row = this.NewList[7];
      if (num === 0) {
        this.$router.push({
          name: "news6",
          query: { topIndex: 0 },
        });
        localStorage.setItem("lobannerIndex", 0);
      }
      if (num === 1) {
        this.$router.push({
          name: "news6",
          query: { topIndex: 0 },
        });
        localStorage.setItem("lobannerIndex", 0);
      }
      if (num === 2) {
        this.$router.push({
          name: "news6",
          query: { topIndex: 0 },
        });
        localStorage.setItem("lobannerIndex", 0);
      }
      localStorage.setItem("bannerList", JSON.stringify(row.children));
    },

    jumpPage(index, num) {
      var row = this.NewList[index];
      if (index === 1) {
        this.$router.push({
          name: "news",
          query: { topIndex: index },
        });
        localStorage.setItem("lobannerIndex", 0);
      }
      if (index === 2) {
        if (num == 1) {
          this.$router.push({
            name: "exhibition",
            query: { topIndex: index },
          });
          localStorage.setItem("lobannerIndex", 1);
        } else {
          this.$router.push({
            name: "exhibition",
            query: { topIndex: index },
          });
          localStorage.setItem("lobannerIndex", 2);
        }
      }
      if (index === 3) {
        this.$router.push({
          name: "news3",
          query: { topIndex: index },
        });
        localStorage.setItem("lobannerIndex", 0);
      }
      if (index === 4) {
        this.$router.push({
          name: "news4",
          query: { topIndex: index },
        });
        localStorage.setItem("lobannerIndex", 2);
      }
      if (index === 5) {
        this.$router.push({
          name: "news5",
          query: { topIndex: index },
        });
        localStorage.setItem("lobannerIndex", 1);
      }
      if (index === 8) {
        this.$router.push({
          name: "news2",
          query: { topIndex: 0 },
        });
        localStorage.setItem("lobannerIndex", 0);
      }
      localStorage.setItem("bannerList", JSON.stringify(row.children));
    },

    async getImgList() {
      const { data } = await selectTNewsPage({
        projectTypeParentId: 3,
        projectTypeSubId: 19,
      });
      this.bussinessList = data.data.list;
      this.bussinessList[0].cover.split(",").forEach((item) => {
        this.bisImgList.push(item);
      });
    },

    changeImg(index) {
      this.bisImgList = [];
      this.bussinessList[index].cover.split(",").forEach((item) => {
        this.bisImgList.push(item);
      });
    },

    // 开发中提示
    developingClick() {
      this.$message({
        showClose: true,
        message: "开发中",
        type: "warning",
        offset: 100,
      });
      // if (index === 8) {
      //   const routeUrl = this.$router.resolve({
      //     path: "/publicList",
      //     query: { type: "service" },
      //   });
      //   window.open(routeUrl.href, "_blank");
      // } else {
      //   this.$message({
      //     showClose: true,
      //     message: "开发中",
      //     type: "warning",
      //   });
      // }
    },
  },
};
</script>

<style lang="less" scoped>
* {
  padding: 0;
  margin: 0;
}

.banner img {
  width: 100%;
  height: 100%;
}

/deep/ .el-carousel__indicator--horizontal .el-carousel__button {
  width: 10px;
  height: 10px;
  background: transparent;
  border: 1px solid #ffffff;
  border-radius: 50%;
  opacity: 0.5;
}
/deep/ .el-carousel__indicator--horizontal.is-active .el-carousel__button {
  width: 10px;
  height: 10px;
  background: #ffffff;
  border-radius: 50%;
  opacity: 1;
}

.home-content {
  width: 100%;
  height: 100%;
  background-color: #ffffff;

  .home-part1 {
    width: 100%;
    background-color: #ffffff;
    text-align: left;

    .home-part1-content {
      width: 86%;
      max-width: 1440px;
      height: 100%;
      margin: 0 auto;
      padding: 20px 0;
      box-sizing: border-box;

      .part1-title {
        margin-bottom: 47px;
        font-weight: bold;
        font-size: 48px;
        color: #191919;
        line-height: 45px;
      }
      .part1-msg {
        width: 856px;
        height: 76px;
        text-align: left;
        font-weight: bold;
        font-size: 32px;
        color: #191919;
        line-height: 45px;
        margin-bottom: 57px;
      }
      .part1-flex {
        width: 100%;
        display: flex;
        justify-content: space-between;

        .part1-flex-item {
          cursor: pointer;
          width: 20%;
          height: 150px;
          background: #f4f5f5;
          padding: 30px 25px 25px 30px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          .item-black {
            display: block;
          }
          .item-white {
            display: none;
            transition: transform 0.6s ease;
          }

          .item-left {
            text-align: right;

            .item-left-title {
              font-weight: 500;
              font-size: 32px;
              color: #dbdbdb;
            }
            .item-left-msg {
              font-weight: 500;
              font-size: 24px;
              color: #191919;
            }
            .item-left-eng {
              font-weight: 500;
              font-size: 12px;
              color: #636366;
            }
          }
        }
        .part1-flex-item:hover {
          background: #4778a9;
        }
        .part1-flex-item:hover .item-left-title {
          color: #80a4cc;
        }
        .part1-flex-item:hover .item-left-msg {
          color: #ffffff;
        }
        .part1-flex-item:hover .item-left-eng {
          color: #89b0da;
        }
        .part1-flex-item:hover .item-white {
          display: block;
          transform: scale(1.3);
        }
        .part1-flex-item:hover .item-black {
          display: none;
        }
      }
    }
  }

  .home-part2 {
    width: 100%;
    height: 750px;
    background-color: #f4f5f5;

    .home-part2-content {
      width: 86%;
      max-width: 1440px;
      height: 100%;
      margin: 0 auto;
      padding-top: 63px;
      box-sizing: border-box;

      .home-part2-title {
        width: 800px;
        height: 120px;
        text-align: left;
        font-weight: bold;
        font-size: 48px;
        color: #191919;
        line-height: 45px;
        background: url(../assets/images/R&D-CENTER.png) no-repeat 0px 36px;
      }

      .home-part2-flex {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .home-part2-left {
          width: 50%;
          padding: 0 3%;
          box-sizing: border-box;

          .home-part2-left-item {
            height: 80px;
            cursor: pointer;
            margin: 40px 0;
            box-sizing: border-box;
            display: flex;
            align-items: center;

            .part2-item-left {
              font-weight: bold;
              font-size: 50px;
              color: #f3f3f3;
              line-height: 68px;
              margin-right: 10px;
              text-stroke: 1px #5e7083;
              -webkit-text-stroke: 1px #5e7083;
            }

            .part2-item-middle {
              flex: 1;
              text-align: left;

              p {
                width: 100%;
                font-weight: 400;
                font-size: 14px;
                color: #636366;
                line-height: 22px;
              }
              .item-mid-top {
                font-weight: 500;
                font-size: 24px;
                color: #191919;
                line-height: 38px;
              }
            }
            .part2-item-right {
              width: 80px;
              height: 100%;
              display: flex;
              align-items: center;
            }
          }
          .home-part2-img {
            width: 0;
          }

          .home-part2-left-item:hover {
            border-bottom: 1px solid #cccccc;
          }

          .home-part2-left-item:hover .home-part2-img {
            width: 80px;
            transition: all 0.5s linear 0.2s;
          }
        }

        .home-part2-right {
          width: 50%;
          height: 460px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .home-part3 {
    width: 100%;
    height: 870px;
    background: #ffffff;

    .home-part3-content {
      width: 86%;
      max-width: 1440px;
      height: 870px;
      margin: 0 auto;
      padding: 60px 0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;

      .home-part3-left {
        width: 48%;
        height: 100%;
        background: #f4f5f5;

        .home-part3-title {
          height: 120px;
          text-align: left;
          font-weight: bold;
          font-size: 48px;
          color: #191919;
          line-height: 45px;
          background: #ffffff url(../assets/images/NEWS1.png) no-repeat 0px 36px;
        }

        .part3-left {
          cursor: pointer;
          width: 100%;
          .part-left-img {
            width: 100%;
            height: 400px;
          }
          img {
            width: 100%;
            height: 400px;
          }

          .text {
            width: 100%;
            text-align: left;
            padding: 35px 24px 20px;
            box-sizing: border-box;

            h5 {
              font-weight: 500;
              font-size: 20px;
              color: #185da0;
              line-height: 38px;
            }
            span {
              font-weight: 400;
              font-size: 12px;
              color: #636366;
              line-height: 22px;
            }
            p {
              margin-top: 10px;
              font-weight: 400;
              font-size: 14px;
              color: #636366;
              line-height: 22px;
            }
          }
        }
      }
      .home-part3-right {
        width: 48%;
        height: 100%;
        padding-top: 34px;
        box-sizing: border-box;

        .tabs {
          width: 100%;
          height: 40px;
          border-bottom: 1px solid #cccccc;
          text-align: left;
          margin-bottom: 40px;
          span {
            cursor: pointer;
            float: left;
            text-align: center;
            display: block;
            width: 100px;
            height: 40px;
            font-size: 18px;
            line-height: 40px;
          }
          .fl {
            background: #4778a9;
            color: #ffffff;
          }

          p {
            cursor: pointer;
            float: right;
            height: 40px;
            line-height: 40px;
          }
        }

        .news-list {
          width: 100%;
          background: #f4f5f5;
          padding: 20px 20px 20px 30px;
          box-sizing: border-box;

          li {
            cursor: pointer;
            width: 100%;
            text-align: left;
            margin-bottom: 21px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .news-span1 {
              font-size: 12px;
              color: #636366;
              line-height: 22px;
              padding-left: 20px;
            }
            .news-span2 {
              width: 80%;
              font-weight: 500;
              font-size: 14px;
              color: #191919;
              line-height: 38px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .news-span2:hover{
              color: #0000ff;
              text-decoration: underline;
           
            }
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 1550px) {
  .home-left {
    flex: 1 !important;

    .home-left-float {
      position: fixed;
      top: 46%;
      left: 1.5% !important;
      width: 57px;
      height: 353px;
      background: #ffffff;
    }
  }

  .home-three-right-content {
    padding-top: 4px;
    margin-top: 2.5%;
    height: 509px !important;
    background: #ffffff;
  }

  .home-right {
    flex: 1 !important;
  }
}

@media only screen and (max-width: 1800px) {
  .home-three-right-content {
    padding-top: 4px;
    margin-top: 2.5%;
    height: 509px !important;
    background: #ffffff;
  }
}
</style>


